import { Flex, IconButton } from '@chakra-ui/react'
import { RiLayoutMasonryLine, RiGridFill, RiRectangleLine } from 'react-icons/ri'

import type { LayoutMode } from '../types'

interface LayoutToggleProps {
  layoutMode: LayoutMode
  onChangeLayout: (mode: LayoutMode) => void
}

const modes: { mode: LayoutMode; icon: React.ReactElement; label: string }[] = [
  { mode: 'masonry', icon: <RiLayoutMasonryLine />, label: 'Masonry layout' },
  { mode: 'grid', icon: <RiGridFill />, label: 'Grid layout' },
  { mode: 'large', icon: <RiRectangleLine />, label: 'Large cards layout' }
]

export default function LayoutToggle({
  layoutMode,
  onChangeLayout
}: LayoutToggleProps) {
  return (
    <Flex
      bg="bg.secondary"
      borderRadius="10px"
      p="4px"
      border="1px solid"
      borderColor="border.subtle"
      gap="2px"
    >
      {modes.map(({ mode, icon, label }) => {
        const isActive = layoutMode === mode
        return (
          <IconButton
            key={mode}
            aria-label={label}
            w="32px"
            h="32px"
            minW="32px"
            borderRadius="8px"
            bg={isActive ? 'bg.surface' : 'transparent'}
            color={isActive ? 'text.primary' : 'text.tertiary'}
            _hover={
              isActive
                ? {}
                : { color: 'text.secondary' }
            }
            transition="all 0.2s ease"
            onClick={() => onChangeLayout(mode)}
            fontSize="16px"
          >
            {icon}
          </IconButton>
        )
      })}
    </Flex>
  )
}
